import Line from './Line';

export function distanceToLine(points, point) {
  let minDistance = Infinity;
  for (let i = 0; i < points.length - 1; i++) {
    const distance = distanceToSegment(points[i], points[i + 1], point);
    if (distance < minDistance) {
      minDistance = distance;
    }
  }
  return minDistance;
}

function distanceToSegment(start, end, point) {
  const [x, y] = point;
  const [x1, y1] = start;
  const [x2, y2] = end;

  const A = x - x1;
  const B = y - y1;
  const C = x2 - x1;
  const D = y2 - y1;

  const dot = A * C + B * D;
  const lenSq = C * C + D * D;
  let param = -1;
  if (lenSq !== 0) {
    param = dot / lenSq;
  }

  let xx, yy;

  if (param < 0) {
    xx = x1;
    yy = y1;
  } else if (param > 1) {
    xx = x2;
    yy = y2;
  } else {
    xx = x1 + param * C;
    yy = y1 + param * D;
  }

  const dx = x - xx;
  const dy = y - yy;
  return Math.sqrt(dx * dx + dy * dy);
}


export function generateParallelLines(lastLine, count, gsd, direction, distance) {
  // console.log('generateParallelLines called with:', { lastLine, count, gsd, direction, distance });
  if (!lastLine || lastLine.points.length < 2) {
    console.error('Invalid line to parallelize');
    return [];
  }

  const parallelLines = [];
  const points = lastLine.points;
  const distanceInMeters = distance * 100 * 0.3048 // convert feet to meters

  for (let i = 1; i <= count; i++) {
    const newLinePoints = [];
    
    for (let j = 0; j < points.length; j++) {
      let perpVector;
      
      if (j === 0) {
        perpVector = getPerpendicular(points[0], points[1]);
      } else if (j === points.length - 1) {
        perpVector = getPerpendicular(points[j-1], points[j]);
      } else {
        const perp1 = getPerpendicular(points[j-1], points[j]);
        const perp2 = getPerpendicular(points[j], points[j+1]);
        perpVector = [(perp1[0] + perp2[0]) / 2, (perp1[1] + perp2[1]) / 2];
      }

      const length = Math.sqrt(perpVector[0]**2 + perpVector[1]**2);
      if (length === 0) {
        console.error('Zero length perpendicular vector');
        continue;
      }
      
      const scaleFactor = i * distanceInMeters * (1 / gsd) / length;
      perpVector = [perpVector[0] * scaleFactor, perpVector[1] * scaleFactor];

      if (direction === -1 || direction === -1) { // -1 is left, -1 is up
        perpVector = [-perpVector[0], -perpVector[1]];
      }

      newLinePoints.push([
        points[j][0] + perpVector[0],
        points[j][1] + perpVector[1]
      ]);
    }

    if (newLinePoints.length >= 2) {
      parallelLines.push(new Line(newLinePoints));
    }
  }

  // console.log('Generated parallel lines:', parallelLines);

  return parallelLines;
}

function getPerpendicular(p1, p2) {
  const dx = p2[0] - p1[0];
  const dy = p2[1] - p1[1];
  return [-dy, dx];
}


export function downscaleImage(imageUrl, maxWidth, maxHeight) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      let width = img.width;
      let height = img.height;

      if (width > maxWidth) {
        height *= maxWidth / width;
        width = maxWidth;
      }
      if (height > maxHeight) {
        width *= maxHeight / height;
        height = maxHeight;
      }

      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, width, height);
      
      resolve(canvas.toDataURL());
    };
    img.onerror = reject;
    img.src = imageUrl;
  });
}


